import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PatientSelectionState {
  /** FHIR id of the patient currently in context across the app. */
  activePatientFhirId: string | null;
  setActivePatient: (fhirId: string) => void;
  clear: () => void;
}

/**
 * Holds the *selection* of the active patient (which dependent the user is
 * viewing). The patient list itself is server state owned by TanStack Query;
 * this store only persists the chosen FHIR id so it survives reloads.
 */
export const usePatientStore = create<PatientSelectionState>()(
  persist(
    (set) => ({
      activePatientFhirId: null,
      setActivePatient: (fhirId) => set({ activePatientFhirId: fhirId }),
      clear: () => set({ activePatientFhirId: null }),
    }),
    { name: 'gral.patient' },
  ),
);
